import { api, ApiResponse } from './api';

export interface WorkspaceMember {
  id: string;
  workspace_id: string;
  user_id: string;
  role: 'admin' | 'manager' | 'member' | 'viewer';
  status: string;
  invited_at?: string;
  invited_by?: string;
  joined_at?: string;
  created_at: string;
  name: string;
  email: string;
  avatar?: string;
}

export const workspaceMemberApi = {
  getAll: async (workspaceId: string): Promise<WorkspaceMember[]> => {
    const response = await api.get<ApiResponse<WorkspaceMember[]>>(`/api/v1/workspaces/${workspaceId}/members`);
    return response.data.data || [];
  },

  invite: async (workspaceId: string, email: string, firstName: string, role: string = 'member'): Promise<WorkspaceMember> => {
    const response = await api.post<ApiResponse<WorkspaceMember>>(`/api/v1/workspaces/${workspaceId}/members/invite`, { email, first_name: firstName, role });
    return response.data.data!;
  },

  updateRole: async (workspaceId: string, memberId: string, role: string): Promise<WorkspaceMember> => {
    const response = await api.patch<ApiResponse<WorkspaceMember>>(`/api/v1/workspaces/${workspaceId}/members/${memberId}/role`, { role });
    return response.data.data!;
  },

  remove: async (workspaceId: string, memberId: string): Promise<void> => {
    await api.delete(`/api/v1/workspaces/${workspaceId}/members/${memberId}`);
  },
};
